import { render, staticRenderFns } from "./NotificationSingleView.vue?vue&type=template&id=7aff630e&scoped=true"
import script from "./NotificationSingleView.vue?vue&type=script&lang=js"
export * from "./NotificationSingleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff630e",
  null
  
)

export default component.exports